import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { Button, Link, Text } from '@nerdwallet/currency';
import StructuredContent from '@nerdwallet/structured-content';

export const ARTICLE_TYPE = {
  EXTERNAL: 'EXTERNAL',
  PAGE_PREVIEW: 'PAGE_PREVIEW',
  INTERNAL: 'INTERNAL',
};

class PressArticle extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderSourceName() {
    const { mediaSites } = this.props.article;
    if (mediaSites && mediaSites[0]?.name) {
      const sourceName = mediaSites[0].name;
      return (
        <Text size="default" bold>
          {sourceName}
        </Text>
      );
    }
    return null;
  }

  renderPreviewLink() {
    const { previewLinkText, type, url } = this.props.article;

    if (type !== ARTICLE_TYPE.PAGE_PREVIEW) {
      return (
        <Link href={url} target="_blank" rel="noopener noreferrer">
          Read more
        </Link>
      );
    }

    return (
      <div className="press-article__btn">
        <Button primary href={url}>
          {previewLinkText}
        </Button>
      </div>
    );
  }

  renderByline() {
    const { article } = this.props;
    const { type } = article;
    const rawAuthors = article.author;

    if (type !== ARTICLE_TYPE.INTERNAL) {
      return null;
    }

    const authors = _.map(rawAuthors, (authorDetails, i) => {
      let { name, link } = authorDetails;
      name = name || 'NerdWallet';
      link = link || '';

      return (
        <Link href={link} key={i}>
          {name}
        </Link>
      );
    });

    const byline = [];

    _.forEach(authors, (author, i) => {
      byline.push(author);

      if (i < authors.length - 2) {
        byline.push(', ');
      } else if (i === authors.length - 2) {
        byline.push(' and ');
      }
    });

    const defaultAvatar =
      'https://secure.gravatar.com/avatar/b17f02f43fecdf671277bc182598db9b?s=96&amp;d=mm&amp;r=g';
    const avatar =
      rawAuthors.length > 2
        ? defaultAvatar
        : _.get(rawAuthors, '[0].avatar_urls.[96]', defaultAvatar);

    return (
      <div className="press-article__byline">
        <Link
          className="press-article__link"
          href={_.get(rawAuthors, '0.link', '')}
        >
          <img
            alt=""
            src={avatar}
            className="press-article__circle"
            height="96"
            width="96"
          />
        </Link>
        <span className="press-article__author">by {byline}</span>
      </div>
    );
  }

  render() {
    const { title, featuredMedia, url, className, content, type } =
      this.props.article;
    const linkProps =
      type !== ARTICLE_TYPE.EXTERNAL
        ? {}
        : { target: '_blank', rel: 'noopener noreferrer' };
    const imageStyle = {
      backgroundPosition: 'center',
    };
    const imageUrl =
      featuredMedia?.sourceUrl ||
      'https://www.nerdwallet.com/assets/img/nw-logos/NW-default_og-image.jpg';
    imageStyle.backgroundImage = `url(${imageUrl})`;

    return (
      <div className={classnames('press-article', className)}>
        <Link href={url} {...linkProps}>
          <div className="press-article__img" style={imageStyle}>
            <div className="press-article__overlay" />
          </div>
        </Link>
        <div className="press-article__content">
          <div>
            {this.renderSourceName()}
            <Link href={url} color="neutral-darkest" {...linkProps}>
              <div className={classnames(['press-article__title'])}>
                <Text size="large" bold>
                  {title}
                </Text>
              </div>
            </Link>
            {this.renderByline()}
            <div className="press-article__excerpt">
              {content && <StructuredContent>{content}</StructuredContent>}
            </div>
            {this.renderPreviewLink()}
          </div>
        </div>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PressArticle.propTypes = {
  article: PropTypes.object.isRequired,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PressArticle.displayName = 'PressArticle';

export default PressArticle;
